import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601 } from '../../../../../../../../../utils';
import { CustomerMembership, isSubMonthlyMembershipInterval } from '../../../../../../../../../models/membership';

@Component({
  selector: 'app-edit-customer-membership-bill-date',
  templateUrl: './edit-customer-membership-bill-date.component.html',
  styleUrls: ['./edit-customer-membership-bill-date.component.css']
})
export class EditCustomerMembershipBillDateComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public newBillDate = '';
  public notes = '';

  public errorMessage = '';

  public minDate: string;

  public dateStringFromISO8601 = dateStringFromISO8601;
  public isSubMonthlyMembershipInterval = isSubMonthlyMembershipInterval;
  public abs = Math.abs;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.minDate = moment().add(1, 'days').format('YYYY-MM-DD');

    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public dayDelta(): number | null {
    if (!this.newBillDate) {
      return null;
    }

    return moment(this.newBillDate).startOf('day').diff(moment(this.membership.end_date).startOf('day'), 'days');
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    if (!this.newBillDate) {
      this.errorMessage = 'Please select a bill date.';
      this.loadingEvent.emit(false);
      return;
    }

    if (this.newBillDate < this.minDate) {
      this.errorMessage = 'The new bill date must be tomorrow or later.';
      this.loadingEvent.emit(false);
      return;
    }

    this.customerService
      .editMembershipBillDate(
        this.membership,
        this.newBillDate,
        this.notes
      )
      .then(() => {
        this.savedCallback('Membership bill date edited successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this membership\'s bill date.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
